<div
  [formGroup]="freeSearchForm"
  [ngClass]="theme()"
  class="places-fake-dropdown"
>
  <mat-form-field appearance="outline">
    <div class="input-wrapper">
      <div class="search-wrapper">
        <div class="search-icon-wrapper">
          @if (isLocationLoading()) {
            <app-spinner-circle
              [position]="CssPositionEnum.ABSOLUTE"
              [size]="'1.5rem'"
              class="mr-4"
            ></app-spinner-circle>
          } @else {
            <app-ui-icon
              color="var(--grey-3)"
              name="marker"
              size="md"
            ></app-ui-icon>
          }
        </div>
        <input
          #freeSearchInput
          (focus)="handleFocus()"
          (keydown.enter)="onEnterHit()"
          [matAutocomplete]="auto"
          class="test-search-autocomplete-input"
          formControlName="term"
          matInput
          placeholder="Välj plats"
          type="search"
        >
        @if (freeSearchForm.controls.term.value && !isLocationLoading()) {
          <div (click)="onClear()" class="close-icon-wrapper">
            <app-ui-icon color="var(--grey-3)" name="close" size="md"></app-ui-icon>
          </div>
        }
        @if (!freeSearchForm.controls.term.value && isDropdownActive() && !isLocationLoading()) {
          <div (click)="onDropdownClick($event)" class="fake-dropdown-button__toggle-wrapper">
            @if (placePanelOpen() === true) {
              <app-ui-icon
                class="fake-dropdown-button__toggle"
                color="var(--grey-3)"
                name="chevron_collapse"
              ></app-ui-icon>
            } @else {
              <app-ui-icon
                class="fake-dropdown-button__toggle"
                color="var(--grey-3)"
                name="chevron_expand"
              ></app-ui-icon>
            }
          </div>
        }

      </div>
    </div>
    <mat-autocomplete
      #auto="matAutocomplete"
      (closed)="handleAutocompleteClosed()"
      (opened)="handleAutocompleteOpened()"
      (optionSelected)="handleOptionSelected($event)"
      class="test-search-autocomplete-modal places-fake-dropdown-autocomple-panel"
    >
      @if (popularSuggestItems() && !filteredSuggestItems()) {
        <span class="places-fake-dropdown-suggest-label">populära sökningar</span>
        @if (state().isLocationSearchVisible) {
          <mat-option
            (click)="searchByLocationClick()"
            [id]="'place-suggestion-popular-nara'"
            [value]="null"
            class="places-fake-dropdown-option test-search-autocomplete-place-option-nara-0"
          >
            <span
              class="suggest-item test-search-autocomplete-place-item-nara-0">{{ SearchWidgetLabelsEnum.NARA_MIG }}</span>
          </mat-option>
        }
        @for (popularItem of popularSuggestItems(); let i = $index; track popularItem.id) {
          <mat-option
            [id]="'place-suggestion-popular-' + (i + 1)"
            [ngClass]=" 'test-search-autocomplete-place-option-' + (i + 1)"
            [value]="popularItem.name"
            class="places-fake-dropdown-option"
          >
            <span [ngClass]="'test-search-autocomplete-place-item-' + (i + 1)"
                  class="suggest-item">{{ popularItem.name }}</span>
          </mat-option>
        }
      }

      @if (filteredSuggestItems()) {
        @for (suggestItem of filteredSuggestItems(); let i = $index; track suggestItem.suggestValue) {
          <mat-option
            [id]="'place-suggestion-query-' + i"
            [ngClass]="'test-search-autocomplete-place-option-' + i"
            [value]="suggestItem.suggestValue"
            class="places-fake-dropdown-option"
          >
            <span [ngClass]="'test-search-autocomplete-place-item-' + i"
                  class="suggest-item">{{ suggestItem.suggestValue }}</span>
            <small [ngClass]="'test-search-autocomplete-item-place-annotation-' + i"
                   class="suggest-item-annotation">{{ suggestItem.suggestLabel }}</small>
          </mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
